<template>
  <div id="app" :class="statusBar">
    <!-- 路由匹配到的组件将渲染在这里 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data: function () {
    return {
      statusBar: ''
    }
  },
  mounted () {
    // 适配iphoneX
    let isIphoneX = () => {
      let u = navigator.userAgent
      if (u.indexOf('iPhone') > -1 && (u.indexOf('screenh 812') > -1 || u.indexOf('screenh/812') > -1)) {
        return true
      } else {
        return false
      }
    }
    if (isIphoneX()) {
      this.statusBar = 'statusBar-iphoneX'
    }
  }
}
</script>

<style lang='scss'>
  @import 'sass/common/flexgrid.css';
  @import 'sass/common/mint-ui.css';
  @import 'sass/common/common-core.scss';
  #app{
    max-width: 750px;
    margin: 0 auto;
    // position: relative;
  }
</style>
